import React from "react";
import { Link } from "react-router-dom";
import { ArrowDown } from "lucide-react";

/**
 * PathwayDiagram — visual Level I → Level IV progression for KISSED University.
 * Drop this into University Home, Open Enrollment, and the DTS program page.
 *
 *   <PathwayDiagram highlight="L3" />   // highlights the user's current level
 */
const LEVELS = [
  { key: "L1", roman: "Level I",   title: "Certified Scalp Scientist",            sub: "Foundation · 4 weeks",  to: "/university/program/l1" },
  { key: "L2", roman: "Level II",  title: "Associate Trichologist",               sub: "Career-track · 12 weeks", to: "/university/program/l2" },
  { key: "L3", roman: "Level III", title: "Holistic Trichology Practitioner",     sub: "Clinical certification · 36 weeks", to: "/university/program/l3" },
  { key: "L4", roman: "Level IV",  title: "Doctor of Trichology Science",         sub: "Doctoral · 24 months · application required", to: "/university/program/dts" },
];

export default function PathwayDiagram({ highlight, compact = false }) {
  return (
    <section className={`${compact ? "py-8" : "py-16"} px-6`} data-testid="pathway-diagram">
      <div className="max-w-3xl mx-auto">
        {!compact && (
          <div className="text-center mb-10">
            <div className="text-[11px] tracking-[0.22em] uppercase mb-3 text-purple-900">The KISSED University Pathway</div>
            <h2 className="font-serif text-3xl sm:text-4xl text-slate-900">From foundation to doctoral study — one ladder.</h2>
          </div>
        )}
        <div className="space-y-3">
          {LEVELS.map((l, i) => {
            const active = highlight === l.key;
            return (
              <React.Fragment key={l.key}>
                <Link to={l.to}
                  className={`block rounded-2xl border p-5 transition ${active ? "border-purple-900 bg-purple-50/60 shadow-sm" : "border-slate-200 bg-white hover:border-purple-300"}`}
                  data-testid={`pathway-${l.key.toLowerCase()}`}
                >
                  <div className="flex items-center gap-4">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-serif text-sm ${active ? "bg-purple-900 text-white" : "bg-slate-100 text-slate-600"}`}>
                      {l.key.slice(1)}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-[10px] uppercase tracking-wider text-purple-900">{l.roman}</div>
                      <div className="font-display text-lg text-slate-900">{l.title}</div>
                      <div className="text-xs text-slate-500 mt-0.5">{l.sub}</div>
                    </div>
                  </div>
                </Link>
                {i < LEVELS.length - 1 && (
                  <div className="flex justify-center"><ArrowDown className="w-4 h-4 text-slate-300" /></div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
}
